import {Button, HeaderTitle} from '@/components/atoms'
import {ProductComboFooter} from '@/containers/ProductCombo/CreateProductCombo/ProductComboFooter'
import {ProductComboStep, ProductComboSteps} from '@/containers/ProductCombo/CreateProductCombo/ProductComboStep'
import {useProductCombo} from '@/context/ProductCombo/ProductComboContext'
import {Header} from '@/utils/constants/header'
import {ROUTES} from '@/utils/constants/routesConstants'
import {productCombinationProgressLevelSteps} from '@/utils/productCombo/productComboConstants'
import {ProgressIndicator} from 'pepsico-ds'
import {useMatch, useNavigate} from 'react-router-dom'
import {PublishedComboHeader} from './ComboDetail/PublishedComboHeader'

export const CreateProductCombo = () => {
  const {
    currentStep,
    setCurrentStep,
    productCombo: {isDraft},
  } = useProductCombo()
  const navigate = useNavigate()
  const isComboDetailPage = Boolean(useMatch(ROUTES.PRODUCT_COMBO_DETAIL))

  const isDetailsView = currentStep === ProductComboSteps.REVIEW && isComboDetailPage

  const handleBack = () => {
    if (isDetailsView || currentStep === ProductComboSteps.SETUP) {
      navigate(ROUTES.PRODUCTS_LIST)
      return
    }

    setCurrentStep(previousStep => previousStep - 1)
  }

  return (
    <div className="flex flex-col gap-4">
      <Button
        uiSchema={{title: 'Back', variant: 'tertiary', iconLeading: 'arrow_back_ios'}}
        handleButton={handleBack}
        id={'product-combination-back'}
      />
      {isDetailsView ? (
        <PublishedComboHeader />
      ) : (
        <>
          <HeaderTitle
            title={isDraft === false ? 'Edit Combo' : 'Create Combo'}
            headingLevel={Header.PageHeader}
            className="$font-heading-h3-bold"
          />
          <ProgressIndicator
            currentStep={currentStep}
            steps={4}
            titles={productCombinationProgressLevelSteps}
            isDark={false}
            className="p-6"
          />
        </>
      )}

      <ProductComboStep step={currentStep} />

      {!isDetailsView && <ProductComboFooter />}
    </div>
  )
}
